import { S_SITE_MODALS, webStorage } from "../utils/webStorage";
import config from "../temp/config";
import { dataFetcher } from "../dataFetcher";
import { dataApi } from "@sitecore-jss/sitecore-jss-react";

export const getModalContent = async (route, lang) => {
  const modals = webStorage.get(S_SITE_MODALS) ?? {};
  if (!modals[route]) modals[route] = {};
  if (!modals[route][lang]) {
    const fetchOptions = {
      layoutServiceConfig: { host: config.sitecoreApiHost },
      querystringParams: { sc_lang: lang, sc_apikey: config.sitecoreApiKey },
      fetcher: dataFetcher
    };
    try {
      modals[route][lang] = await dataApi.fetchRouteData(route, fetchOptions);
      webStorage.set(S_SITE_MODALS, modals);
    } catch (error) {
      if (error.response) {
        return error.response;
      }
      console.error("Route data fetch error", error, error.response);
      return null;
    }
  }
  return modals[route][lang];
};
